<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0001_reset_password</div>
      <div style="color: #000000;font-size: 30px;padding: 27px 50px;font-weight: 800;background:#5b9bd5;color: #FFFFFF">
        ソフトウェアライセンス管理
        <br><div style="font-size:20px;color: #FFFFFF">e-sma</div>
      </div>
        <div :class="'container ' + pageContainerSize">
        <div class="row">
            <div class="form1 col-xs-3" style="margin-left:-15px;"></div>
            <div class="form1 col-xs-6" style="margin-left:-15px;">
              <title-and-slot title="PWロック解除" ></title-and-slot>
              <br><br>
                <field-box
                  v-for="f in formFields.col1"  
                  v-bind:key="f.id" 
                  v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
                  <br>
            </div>
        </div>
        <div class="row">
          <div class="form1 col-xs-3" style="margin:-5px 15px 15px -15px;"></div>
          <div class="form1 col-xs-6" style="margin:-5px 15px 15px -15px;">
            ライセンス管理窓口にて内容を確認後、パスワードロック解除を行います。<br>
            作業後にご連絡いたしますので、速やかにログインできることをご確認頂きますようお願いいたします。<br><br>
            <button class="btn btn-primary" style="float:left;min-width:130px;" @click="backToList">戻る</button>
            <button 
            :disabled="disallowToSubmit"
            class="btn btn-info" 
            style="float:right;min-width:130px;"
            @click="onSubmit"
            >申請</button>
          </div>
        </div>
      </div>
      <confirmation-modal tag="ResetPasswordModal"/>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_id_approval_history';　
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:inventory_report');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
import axios from "axios";
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
  },
  data() {
    return {
      api_name:"reset_password",
      page_acl: acl.master_user_password,
      show_chose_file:true,
      file_selected_event: false,
      selected_file_name: null,
      is_uploading:false
    };
  },
  computed: {
    isUploading:{
      get(){
        return this.is_uploading;
      },
      set(v){
        this.is_uploading = v;
      }
    },
    disallowToSubmit(){
      return false;
    },
    selectedFileName:{
      get(){
        return this.selected_file_name;
      },
      set(v){
        this.selected_file_name = v;
      }
    },
    showChoseFile:{
      get(){
        return this.show_chose_file;
      },
      set(v){
        this.show_chose_file = v;
      }
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1:[
         utils.extend(fields.name, {}),
         utils.extend(fields.mail_address, {}),
         utils.extend(fields.user_id, {}),
         utils.extend(fields.role, {}),
        ]
      }
    }
  },
  methods: {
    onSubmit(){
      this.$notify({clear:true})
      var disallow_submit = this.disallowToSubmit;
      this.formFields.col1.forEach(e=>{
        var v = this.$store.state[this.stateCurrentEditing][e.id]
        if(typeof v == "undefiend" || v == null || v.length == 0){
          disallow_submit = true;
          this.$notify({
            text: e.label + "は必須項目になります。",
            type: 'error',
            duration: 15000
          });
        }
      })

      if(disallow_submit == false){
        this.isUploading = true;
        // Ready to submit.
        var form_data = new FormData();
        this.formFields.col1.forEach(e=>{
          var v = this.$store.state[this.stateCurrentEditing][e.id]
          form_data.append(e.id, v);
        })

        axios.post(this.$ajax.serverUrl + "/" + this.api_name + "/reset_request", form_data, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          var data = response.data;
          bus.$emit("ResetPasswordModal",{
            title: "", 
            message: "PWロック解除を送信しました。",
            yes_label: "",
            no_label: "戻る",
            yes_color:"info",
            no_color:"default",
            model_height:"50"
          })
        })
      }
    },
    choseFile(){
      var csv_file = this.$refs.csv_file;
      csv_file.click();
    },
    fileClicked(e) {
      var csv_file = this.$refs.csv_file;
      csv_file.value = null;
    },
    fileSelected(e) {
      var files = e.target.files;
      if (!files[0]) {
        return;
      }
      this.file_selected_event = e;
      this.selectedFileName = files[0].name;
    },
    backToList(){
      return this.$router.go(-1);
    },

  },
  mounted() {
    this.formFields.col1.forEach(e=>{
      this.$store.state[this.stateCurrentRow][e.id] = "";
    })
    this.$route.params.seq_id = "new";
    this.$store.state[this.stateIsEditingNew] = true;
    this.read_only = false;
    this.is_new = true;
  },
  beforeMount() {
  },
  beforeDestroy() {
  },
};

</script>
<style scoped>

.report_field {
  width: 80%;
  height: 30px;
  background:#A6A6A6;
  text-align: start;
  color:#ffffff;
  line-height: 30px;
  margin-left: -10px;
}

.report_field_select{
float: left; 
line-height: 25px;
width: 230px;
}
.line1{
line-height: 25px;
width: 120px;
}
.textbox{
line-height: 25px;
}
.form1{
max-width: 550px;
margin-top: 30px;
margin-bottom: 30px;
}
.input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>


// WEBPACK FOOTER //
// page_0001_reset_password.vue?42ad9102